import { render, staticRenderFns } from "./addgallery.vue?vue&type=template&id=719cf1f0&scoped=true"
import script from "./addgallery.vue?vue&type=script&lang=js"
export * from "./addgallery.vue?vue&type=script&lang=js"
import style0 from "./addgallery.vue?vue&type=style&index=0&id=719cf1f0&scoped=true&lang=scss"
import style1 from "./addgallery.vue?vue&type=style&index=1&id=719cf1f0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719cf1f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('719cf1f0')) {
      api.createRecord('719cf1f0', component.options)
    } else {
      api.reload('719cf1f0', component.options)
    }
    module.hot.accept("./addgallery.vue?vue&type=template&id=719cf1f0&scoped=true", function () {
      api.rerender('719cf1f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gallery/addgallery.vue"
export default component.exports